/**
 * @generated SignedSource<<deb8dc548bac2381f539e8316cad3232>>
 * @relayHash a7c5c4d6570548dfbbb896009ae5fc47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
export type uiJiraSoftwareEditSprintModalQuery$variables = {
  boardId: string;
  fetchSprints: boolean;
  sprintId: string;
};
export type uiJiraSoftwareEditSprintModalQuery$data = {
  readonly boardScope: {
    readonly sprint: {
      readonly endDate: AGG$DateTime | null | undefined;
      readonly goal: string | null | undefined;
      readonly id: string | null | undefined;
      readonly name: string;
      readonly sprintState: SprintState;
      readonly startDate: AGG$DateTime | null | undefined;
    };
    readonly sprints?: ReadonlyArray<{
      readonly endDate: AGG$DateTime | null | undefined;
      readonly goal: string | null | undefined;
      readonly id: string | null | undefined;
      readonly name: string;
      readonly sprintState: SprintState;
      readonly startDate: AGG$DateTime | null | undefined;
    } | null | undefined> | null | undefined;
  };
};
export type uiJiraSoftwareEditSprintModalQuery = {
  response: uiJiraSoftwareEditSprintModalQuery$data;
  variables: uiJiraSoftwareEditSprintModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchSprints"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sprintId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "sprintId",
    "variableName": "sprintId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "goal"
},
v8 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v9 = {
  "kind": "ScalarField",
  "name": "endDate"
},
v10 = {
  "kind": "ScalarField",
  "name": "sprintState"
},
v11 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiJiraSoftwareEditSprintModalQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v3/*: any*/),
          "concreteType": "BoardScope",
          "kind": "LinkedField",
          "name": "boardScope",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v4/*: any*/),
                "concreteType": "Sprint",
                "kind": "LinkedField",
                "name": "sprint",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "RequiredField",
                    "field": (v6/*: any*/),
                    "action": "THROW",
                    "path": "boardScope.sprint.name"
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "RequiredField",
                    "field": (v10/*: any*/),
                    "action": "THROW",
                    "path": "boardScope.sprint.sprintState"
                  }
                ]
              },
              "action": "THROW",
              "path": "boardScope.sprint"
            },
            {
              "condition": "fetchSprints",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "Sprint",
                  "kind": "LinkedField",
                  "name": "sprints",
                  "plural": true,
                  "selections": [
                    (v5/*: any*/),
                    {
                      "kind": "RequiredField",
                      "field": (v6/*: any*/),
                      "action": "THROW",
                      "path": "boardScope.sprints.name"
                    },
                    (v7/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    {
                      "kind": "RequiredField",
                      "field": (v10/*: any*/),
                      "action": "THROW",
                      "path": "boardScope.sprints.sprintState"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "boardScope"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiJiraSoftwareEditSprintModalQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "Sprint",
            "kind": "LinkedField",
            "name": "sprint",
            "plural": false,
            "selections": (v11/*: any*/)
          },
          {
            "condition": "fetchSprints",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "Sprint",
                "kind": "LinkedField",
                "name": "sprints",
                "plural": true,
                "selections": (v11/*: any*/)
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b",
    "metadata": {},
    "name": "uiJiraSoftwareEditSprintModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c7b9c1c33647526da24d1f5d937ea327";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
